/** PER-ACCOUNT (immutable `accountType`), not per-org. The ONE sanctioned place a whole shell branches on it. */
export const isCandidateExperience = (
  accountType: string | null | undefined,
): boolean => accountType === 'CANDIDATE';
